import { Stack, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { icons } from "assets/AssetHelper";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";

export default function CustomerInfo({ details }) {
  const { t } = useTranslation();
  const customerInfo = {
    [t("admin_users.col_name")]: details?.orderer?.customer_name,
    [t("vendors.label_mobile")]:
      `+(${details?.orderer?.customer_country_code}) ${details?.orderer?.customer_phone_number}`,
    [t("auth.login.email_label")]: details?.orderer?.email,
    [t("vendors.label_location")]: details?.delivery_address?.full_address,
  };

  const cardStyle = {
    width: { xs: "100%", md: "47%" },
    backgroundColor: "white",
    p: 3,
    gap: 3,
    boxSizing: "border-box",
    borderRadius: "8px",
  };

  return (
    <Stack sx={cardStyle}>
      {/* ----------- CARD HEADER ----------- */}
      <Stack direction="row" justifyContent="space-between">
        <Stack direction="row" alignItems="center" gap={2}>
          <Box component="img" width="46px" src={icons.userInfo} />
          <Typography fontWeight="500" fontSize={{ xs: "18px", sm: "24px" }}>
            {t("profile.user_info")}
          </Typography>
        </Stack>
        {details?.order_complaint && (
          <Stack
            direction="row"
            alignItems="center"
            gap={1}
            sx={{ cursor: "pointer" }}
          >
            <VisibilityOutlinedIcon />
            <Typography>{t("complaints.view_details")}</Typography>
          </Stack>
        )}
      </Stack>
      {/* ----------- CARD INFO ----------- */}
      <Stack gap={2}>
        {Object.keys(customerInfo).map((key, i) => (
          <Stack key={i} direction="row" justifyContent="space-between">
            <Typography sx={{ width: "20%", color: "#969696", fontSize: { xs: "13px", sm: "16px" } }}>
              {key}
            </Typography>
            <Typography sx={{ width: "77%", fontSize: { xs: "14px", sm: "16px" } }}>{customerInfo[key]}</Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}
